/** Formulario de contacto (Tally) — misma URL en home (#contacto) y /contacto */
export const TALLY_CONTACT_FORM_ID = "vGxlv4" as const;

export const TALLY_WIDGET_SCRIPT = "https://tally.so/widgets/embed.js" as const;

/** `formEventsForwarding=1` reenvía eventos al parent vía postMessage (PostHog en `tallyEmbedTracking`). */
export const TALLY_CONTACT_EMBED_QUERY =
  "alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1&formEventsForwarding=1" as const;

export const TALLY_CONTACT_EMBED_DATA_SRC =
  `https://tally.so/embed/${TALLY_CONTACT_FORM_ID}?${TALLY_CONTACT_EMBED_QUERY}` as const;

/**
 * Arma el data-src del embed de Tally a partir de un formId opcional (admin →
 * site_settings.tally_contact_form_id). Si no se pasa (o viene vacío) usa el
 * TALLY_CONTACT_FORM_ID por defecto → comportamiento idéntico al hardcodeado.
 */
export function buildTallyContactEmbedDataSrc(formId?: string): string {
  const id = formId && formId.trim() ? formId.trim() : TALLY_CONTACT_FORM_ID;
  return `https://tally.so/embed/${id}?${TALLY_CONTACT_EMBED_QUERY}`;
}
